<h1 mat-dialog-title>{{ title }}</h1>

<div mat-dialog-actions class="dialog-action">
  <button mat-raised-button [mat-dialog-close]="true">{{ closeLabel }}</button>
  <button mat-raised-button color="warn" (click)="onConfirmLeaveGame()">{{ confirmLeaveGameLabel }}</button>
</div>
